import React from 'react';
import { makeStyles } from '@material-ui/core';
import { getFileFormat } from 'utils/get-file-format';
import FilePreview from '../../assets/blank_file.png';

interface FileFormatProps {
  contentType?: string;
}

const useStyles = makeStyles((theme) => ({
  fileFormatWrapper: {
    position: 'relative',
    width: 20,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  format: {
    position: 'absolute',
    width: 20,
    height: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    fontSize: 8,
    fontWeight: 500,
    borderRadius: 1,
  },
}));

export const FileFormat = ({ contentType }: FileFormatProps) => {
  const classes = useStyles();
  const fileFormat = contentType != null ? getFileFormat(contentType) : '';

  return (
    <div className={classes.fileFormatWrapper}>
      <img src={FilePreview} alt="format" width={15} height={18} />
      <div className={classes.format}>{fileFormat}</div>
    </div>
  );
};
